import React, { useState } from 'react'

import { Route, Link, Routes, useLocation, Navigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import StakeLeaderboard from './Stake/Leaderboard'
import { ReactComponent as Stake } from '../../icons/sites/stake.svg'
import { ReactComponent as CasesGG } from '../../icons/sites/casesgg.svg'
import { ReactComponent as RainGG } from '../../icons/sites/raingg.svg'
import { styled } from '@mui/styles'
import ArrowBackIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIos';
import { IconButton } from '@mui/material'
import DatdropLeaderboard from './Datdrop/Leaderboard'
import { ReactComponent as Hypedrop } from '../../icons/sites/hypedrop.svg'
import HypedropLeaderboard from './Hypedrop/Leaderboard'


const NavButton = styled(Button)(( { theme }) => ({
    height: '56px',
    gap: '.5rem',

    '& > *': {
        opacity: '.8',
        filter: 'grayscale(1)',
        transition: 'opacity .2s ease-in-out, filter .2s ease-in-out',
    },

    '&:hover': {
        '*': {
            opacity: '1',
            filter: 'grayscale(.2)'
        }
    },

    '&.active': {
        '& > *': {
            opacity: '1 !important',
            filter: 'grayscale(0) !important'
        }
    }
}))

const MobileBox = styled(Box)(( { theme }) => ({

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    py: '10px',

    '& > svg': {
        height: 'auto',
        width: '128px',
        maxWidth: '80%'
    },
    '& > img': {
        height: 'auto',
        width: '128px',
        maxWidth: '80%'
    }
}))

enum LeaderboardPath {
    STAKE = "/leaderboard/stake",
    DATDROP = "/leaderboard/datdrop",
    HYPEDROP = "/leaderboard/hypedrop"
}

function getPreviousPath(path: LeaderboardPath) {
    switch (path) {
        case LeaderboardPath.STAKE:
            return null
        case LeaderboardPath.DATDROP:
            return LeaderboardPath.STAKE
        case LeaderboardPath.HYPEDROP:
            return LeaderboardPath.DATDROP
        default:
            return LeaderboardPath.STAKE
    }
}

function getNextPath(path: LeaderboardPath) {
    switch (path) {
        case LeaderboardPath.STAKE:
            return LeaderboardPath.DATDROP
        case LeaderboardPath.DATDROP:
            return LeaderboardPath.HYPEDROP
        case LeaderboardPath.HYPEDROP:
            return null
        default:
            return LeaderboardPath.STAKE
    }
}

const LeaderboardIndexPage = () => {

    let location = useLocation();
    const [value, setValue] = useState(0)

  return (
      <Box sx={{ height: '100%' }}>
            <Box 
                position="sticky" 
                top="84px" 
                zIndex={10}
                sx={{ boxShadow: '0 0 .5rem rgba(0, 0, 0, .25)', backgroundColor: 'var(--primary-bg-soft)', p: '.25rem', borderBottom: '1px solid var(--primary-border)' }}
            >
                <Box 
                    display="flex"
                    alignItems="center"
                    sx={{ height: '56px', px: '1rem', display: { xs: 'flex', sm: 'none' } }}
                >
                    <Link to={getPreviousPath(location.pathname as LeaderboardPath) ?? LeaderboardPath.STAKE}>
                        <IconButton disabled={location.pathname.startsWith(LeaderboardPath.STAKE)}>
                            <ArrowBackIcon sx={{ fill: location.pathname.startsWith(LeaderboardPath.STAKE) ? "rgb(0,0,0) !important" : "" }} />
                        </IconButton>
                    </Link>
                    <Box display="flex" sx={{ width: '100%' }}>
                        {location.pathname.startsWith(LeaderboardPath.STAKE) && (
                            <MobileBox>
                                <Stake style={{ height: 'auto', width: '64px'}}/>
                            </MobileBox>
                        )}
                        {location.pathname.startsWith(LeaderboardPath.DATDROP) && (
                            <MobileBox>
                                <b style={{ fontSize: '2em', fontWeight: '900', fontStyle: 'italic', textTransform: 'uppercase' }}>Datdrop</b>
                            </MobileBox>
                        )}

                        {location.pathname.startsWith(LeaderboardPath.HYPEDROP) && (
                            <MobileBox>
                                <Hypedrop style={{ height: 'auto', width: '64px'}}/>
                            </MobileBox>
                        )}
                    </Box>
                    <Link to={getNextPath(location.pathname as LeaderboardPath) ?? LeaderboardPath.HYPEDROP}>
                        <IconButton disabled={location.pathname.startsWith(LeaderboardPath.HYPEDROP)} onClick={() => setValue(prevState => ++prevState)}>
                            <ArrowForwardIcon sx={{ fill: location.pathname.startsWith(LeaderboardPath.HYPEDROP) ? "rgb(0,0,0) !important" : "" }} />
                        </IconButton>     
                    </Link>              
                </Box>
                <Box         
                    alignItems="center" 
                    justifyContent="center" 
                    gap="2rem"
                    sx={{ height: '56px', display: { xs: 'none', sm: 'flex' }  }}
                >                   
                    <Link to={LeaderboardPath.STAKE}>
                        <NavButton disableRipple className={location.pathname.startsWith(LeaderboardPath.STAKE) ? "active" : ""} sx={{ 'svg': { height: 'auto', width: '64px' } }}>
                            <Stake />
                        </NavButton>
                    </Link>
                    <Link to={LeaderboardPath.DATDROP}>
                        <NavButton disableRipple className={location.pathname.startsWith(LeaderboardPath.DATDROP) ? "active" : ""}>
                            <b style={{ fontSize: '2em', fontWeight: '900', fontStyle: 'italic', textTransform: 'uppercase' }}>Datdrop</b>
                        </NavButton>
                    </Link>
                    <Link to={LeaderboardPath.HYPEDROP}>
                        <NavButton disableRipple className={location.pathname.startsWith(LeaderboardPath.HYPEDROP) ? "active" : ""} sx={{ 'svg': { height: 'auto', width: '64px' } }}>
                            <Hypedrop />
                        </NavButton>
                    </Link>
                </Box>
            </Box>

          <Routes>
              <Route path="/" element={<Navigate to="/leaderboard/stake" />} />
              <Route path="/stake" element={<StakeLeaderboard />} />
              <Route path="/datdrop" element={<DatdropLeaderboard />} />
              <Route path="/hypedrop" element={<HypedropLeaderboard />} />
          </Routes>
    </Box>
  )
}

export default LeaderboardIndexPage